import { useEffect, useState } from "react";
import Container from "@/components/Container";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function SettingsAdmin() {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    api.get("/search-engine/usage").then(r => setUsage(r.data)).catch(() => {});
  }, []);

  const used = usage?.used ?? 0;
  const limit = usage?.limit ?? 200;
  const pct = Math.min(100, (used / Math.max(1, limit)) * 100);
  const bar = pct > 90 ? "bg-ruby" : pct > 70 ? "bg-bronze" : "bg-gold";

  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Library</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Settings</h1>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="luxury-card p-6" data-testid="settings-account">
          <p className="overline">Account</p>
          <dl className="mt-4 space-y-3 text-sm">
            <Row k="Email" v={user?.email} />
            <Row k="Role" v={user?.role} />
            <Row k="Name" v={user?.name} />
          </dl>
        </div>
        <div className="luxury-card p-6" data-testid="settings-brand">
          <p className="overline">Brand</p>
          <dl className="mt-4 space-y-3 text-sm">
            <Row k="Domain" v="rubys.group" />
            <Row k="Email" v="info@rubys.group" />
          </dl>
        </div>

        <div className="luxury-card p-6 md:col-span-2" data-testid="settings-serpapi-usage">
          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="overline">Live Search · SerpAPI usage</p>
              <p className="mt-2 text-ivory/70 text-sm">
                Monthly cap protects budget. Resets on the first of every month.
              </p>
            </div>
            {usage && (
              <p className="font-serif text-2xl text-ivory whitespace-nowrap">
                {used} <span className="text-ivory/40">/ {limit}</span>
              </p>
            )}
          </div>
          <div className="mt-4 h-2 w-full bg-charcoal-700 overflow-hidden">
            <div className={`h-full ${bar} transition-all`} style={{ width: `${pct}%` }} />
          </div>
          {usage && (
            <p className="mt-3 text-[0.65rem] uppercase tracking-[0.18em] text-ivory/50">
              {usage.month} · {usage.remaining} remaining
            </p>
          )}
        </div>
      </div>
    </Container>
  );
}

function Row({ k, v }) {
  return <div className="flex justify-between border-b border-charcoal-600/60 pb-2"><dt className="text-ivory/50 uppercase tracking-[0.15em] text-[0.7rem]">{k}</dt><dd className="text-ivory">{v}</dd></div>;
}
